/**
 * HTML接收参数
 */

import {partPath} from './variables.js'

function getRequestByName(paramName) {
    // 获取URL的字符串
    var sSource = String(parent.parent.location);
    var sName = paramName;
    var sReturn = "";
    var sQUS = "?";
    var sAMP = "&";
    var sEQ = "=";
    var iPos;

    // 获取sSource中的"?"，无则返回 -1
    iPos = sSource.indexOf(sQUS);
    if (iPos == -1)
        return;

    // 汲取参数，从iPos位置到sSource.length-iPos的位置，
    // 若iPos = -1，则：从-1 到 sSource.length+1
    var strQuery = sSource.substr(iPos, sSource.length - iPos);

    // alert(strQuery);
    // 先全部转换为小写
    var strLCQuery = strQuery.toLowerCase();
    var strLCName = sName.toLowerCase();

    // 从子字符串strLCQuery中查找“?”、参数名，以及“=”，即“?参数名=”
    iPos = strLCQuery.indexOf(sQUS + strLCName + sEQ);
    // alert(iPos);
    // 如果不存在
    if (iPos == -1) {
        // 继续查找可能的后一个参数，即带“&参数名=”
        iPos = strLCQuery.indexOf(sAMP + strLCName + sEQ);
    }

    // 判断是否存在参数
    if (iPos != -1) {
        sReturn = strQuery.substr(iPos + sName.length + 2, strQuery.length -
            (iPos + sName.length + 2));
        var iPosAMP = sReturn.indexOf(sAMP);
        if (iPosAMP == -1) {
            return sReturn;
        } else {
            sReturn = sReturn.substr(0, iPosAMP);
        }
    }
    return sReturn;
}

function getRequestByNameFromWin(paramName, win) {
    // 获取URL的字符串
    var sSource = String(win.location);
    var sName = paramName;
    var sReturn = "";
    var sQUS = "?";
    var sAMP = "&";
    var sEQ = "=";
    var iPos;

    // 获取sSource中的"?"，无则返回 -1
    iPos = sSource.indexOf(sQUS);
    if (iPos == -1)
        return;

    // 汲取参数，从iPos位置到sSource.length-iPos的位置，
    // 若iPos = -1，则：从-1 到 sSource.length+1
    var strQuery = sSource.substr(iPos, sSource.length - iPos);

    // alert(strQuery);
    // 先全部转换为小写
    var strLCQuery = strQuery.toLowerCase();
    var strLCName = sName.toLowerCase();

    // 从子字符串strLCQuery中查找“?”、参数名，以及“=”，即“?参数名=”
    iPos = strLCQuery.indexOf(sQUS + strLCName + sEQ);
    // alert(iPos);
    // 如果不存在
    if (iPos == -1) {
        // 继续查找可能的后一个参数，即带“&参数名=”
        iPos = strLCQuery.indexOf(sAMP + strLCName + sEQ);
    }

    // 判断是否存在参数
    if (iPos != -1) {
        sReturn = strQuery.substr(iPos + sName.length + 2, strQuery.length -
            (iPos + sName.length + 2));
        var iPosAMP = sReturn.indexOf(sAMP);
        if (iPosAMP == -1) {
            return sReturn;
        } else {
            sReturn = sReturn.substr(0, iPosAMP);
        }
    }
    return sReturn;
}

function getRequestByNameBySplite(paramName, splite) {
    // 获取URL的字符串
    var sSource = String(parent.parent.location);
    var sName = paramName;
    var sReturn = "";
    var sQUS = splite;
    var sAMP = "&";
    var sEQ = "=";
    var iPos;

    // 获取sSource中的"?"，无则返回 -1
    iPos = sSource.indexOf(sQUS);
    if (iPos == -1)
        return;

    // 汲取参数，从iPos位置到sSource.length-iPos的位置，
    // 若iPos = -1，则：从-1 到 sSource.length+1
    var strQuery = sSource.substr(iPos, sSource.length - iPos);

    // alert(strQuery);
    // 先全部转换为小写
    var strLCQuery = strQuery.toLowerCase();
    var strLCName = sName.toLowerCase();

    // 从子字符串strLCQuery中查找“?”、参数名，以及“=”，即“?参数名=”
    iPos = strLCQuery.indexOf(sQUS + strLCName + sEQ);
    // alert(iPos);
    // 如果不存在
    if (iPos == -1) {
        // 继续查找可能的后一个参数，即带“&参数名=”
        iPos = strLCQuery.indexOf(sAMP + strLCName + sEQ);
    }

    // 判断是否存在参数
    if (iPos != -1) {
        sReturn = strQuery.substr(iPos + sName.length + 2, strQuery.length -
            (iPos + sName.length + 2));
        var iPosAMP = sReturn.indexOf(sAMP);
        if (iPosAMP == -1) {
            return sReturn;
        } else {
            sReturn = sReturn.substr(0, iPosAMP);
            if (sReturn.indexOf(splite) != -1) {
                sReturn = sReturn.substr(0, sReturn.indexOf(splite));
            }
        }
    }
    return sReturn;
}

// 截取字符串区分中英文
function mySubString(str, startLen, len) {
    var newLength = 0;
    var newStr = "";
    var chineseRegex = /[^\x00-\xff]/g;
    var singleChar = "";
    var strLength = str.replace(chineseRegex, "**").length;
    for (var i = 0; i < strLength; i++) {
        singleChar = str.charAt(i).toString();
        if (singleChar.match(chineseRegex) != null) {
            newLength += 2;
        } else {
            newLength++;
        }
        if (newLength > len) {
            break;
        }
        newStr += singleChar;
    }
    if (strLength > len) {
        newStr += "...";
    }
    return newStr;
};

// 格式化标题，显示20个字
function comChangeTitle(title) {
    var nowWord;
    var nowLeng = contentLength(title);
    if (nowLeng > 19) {
        nowWord = mySubString(title, 0, 20);
    } else {
        nowWord = title;
    }
    return nowWord;
};

// 格式化标题，自定义
function changeTitleDiy(title, len) {
    var nowWord;
    var nowLeng = contentLength(title);
    if (nowLeng > len && len > 2) {
        nowWord = mySubString(title, 0, len - 2);
    } else if (nowLeng > len - 1) {
        nowWord = mySubString(title, 0, len);
    } else {
        nowWord = title;
    }
    return nowWord;
};

// 返回文字内容长度
function contentLength(content) {
    var intLength = 0
    for (var i = 0; i < content.length; i++) {
        if ((content.charCodeAt(i) < 0) || (content.charCodeAt(i) > 255))
            intLength = intLength + 2
        else
            intLength = intLength + 1
    }
    return intLength
};

// 返回指定内容长度
function formatColumnLength(name, length) {
    var list = $("tbody [name='" + name + "']");
    $.each(list, function (i, item) {
        $(item).html(changeTitleDiy($(item).html().trim(), length));
    });
}

// 处理内容testarea换行符在html页面不换行的问题
function formatContent() {
    var element = $("#formatContent");
    // var temp = element.text().trim().replace(/\n/g,'<br/>');
    element.html(element.text().trim());
}

function formatContent1() {
    var element = $("#formatContent");
    var temp = element.text().trim().replace(/\n/g, '<br/>');
    element.html(temp);
}

/**
 * 封装Ajax</br> 参数说明：</br> opts: {'可选参数'}</br> type: 请求方式:GET/POST,默认值:'GET';</br>
 * url: 发送请求的地址, 默认值: 当前页地址;</br> data: 请求参数;</br> data: string,json;</br>
 * async: 是否异步:true/false,默认值:true;</br> cache: 是否缓存：true/false,默认值:true;</br>
 * contentType: HTTP头信息，默认值：'application/x-www-form-urlencoded';</br> success:
 * 请求成功后的回调函数;</br> error: 请求失败后的回调函数;</br>
 */
/**
 * 对于公有云后台请求的ajax的封装，全部走网关过滤
 */
function ajaxRequest(opts) {
    var token = window.top.localStorage.getItem("token");
    var configs = JSON.parse(window.localStorage.getItem("configs"));
    //var ccTenantUserInfo = JSON.parse(window.localStorage.getItem("ccTenantUserInfo"));
    if (!configs) {
        jumpToLogin('登录信息失效，缓存中无configs，请重新登录!');
        return;
    }
    if (!token) {
        jumpToLogin('登录信息失效，缓存中无token，请重新登录!');
        return;
    }
    /*if (!ccTenantUserInfo) {
        jumpToLogin('登录信息失效，缓存中无ccTenantUserInfo，请重新登录!');
        return;
    }*/
    /*if (!testVildate()) {
        jumpToLogin('登录信息已超时，请重新登录!');
        return;
    }*/
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: true,
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }

    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            //XHR.setRequestHeader("userId", ccTenantUserInfo.userId);
            //XHR.setRequestHeader("tenantId", ccTenantUserInfo.tenantId);
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          errorHandle(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

function ajaxRequestForFast(opts) {
    try {
        window.parent.updatePortalStorageExpireTime();
    } catch (e) {
        console.warn("redis过期时间更新异常！");
    }
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: false,
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }
    // 获取访问令牌
    var token = window.top.localStorage.getItem("token");
    if (!token) {
        console.warn("当前localStorage中，无token缓存！");
    } else {
        if (!testVildate()) {
            console.warn("当前localStorage中，token信息已经超时，请注意！");
        }
    }
    /*
     * var timeout=1800000; try { if
     * (window.top.location.href.indexOf("ClueCloud") > 0){
     * setTimeout(function(){ window.localStorage.setItem("ccTenantUserInfo",
     * ""); sessionStorage.removeItem("isFirstTime");
     * sessionStorage.removeItem("itemGuid");
     * sessionStorage.removeItem("loginTime"); window.top.location =
     * "login.html"; },timeout); } }catch (e){ // 出现异常不处理 // iframe子页面调用父页面方法
     * window.top.location.href.indexOf 跨域 异常 }
     */
    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            // XHR.setRequestHeader("userId",userId);
            // XHR.setRequestHeader("tenantId",tenantId);
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            errorHandleForFast(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

// 从localStorage获取超时时间戳，判断token是否超时
function testVildate() {
    var expTime = parseInt(window.top.localStorage.getItem("expTime"));
    if (expTime) {
        var nowTime = new Date().getTime();
        if (nowTime > expTime - 2 * 60 * 1000) { // 两分钟的预留时间
            // @TODO 移除token头，重新获取token？
            return false; // token已经过期
        } else {
            return true;
        }
    } else {
        return false; // 缓存中不存在token信息
    }
}

/**
 * 对于台内报料的后台请求的ajax的封装
 *
 * @param opts
 */
function ajaxRequest4Local(opts) {
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: false,
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }
    /*
     * var timeout=1800000; try { if
     * (window.top.location.href.indexOf("ClueCloud") > 0){
     * setTimeout(function(){ window.localStorage.setItem("ccTenantUserInfo",
     * ""); sessionStorage.removeItem("isFirstTime");
     * sessionStorage.removeItem("itemGuid");
     * sessionStorage.removeItem("loginTime"); window.top.location =
     * "login.html"; },timeout); } }catch (e){ // 出现异常不处理 // iframe子页面调用父页面方法
     * window.top.location.href.indexOf 跨域 异常 }
     */
    var userInfo = JSON.parse(window.localStorage.getItem("ccTenantUserInfo"));
    var userId = userInfo.userId;
    var tenantId = userInfo.tenantId;
    var token = userInfo.token;
    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            XHR.setRequestHeader("userId", userId);
            XHR.setRequestHeader("tenantId", tenantId);
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log('请求出错了')
            errorHandle(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

function ajaxRequest4LocalFast(opts) {
    try {
        window.parent.updatePortalStorageExpireTime();
    } catch (e) {
        console.warn("redis过期时间更新异常！");
    }
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: false,
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }
    var userInfo = JSON.parse(window.top.localStorage.getItem("ccTenantUserInfo"));
    var userId = userInfo.userId;
    var tenantId = userInfo.tenantId;
    var token = userInfo.token;
    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            XHR.setRequestHeader("userId", userId);
            XHR.setRequestHeader("tenantId", tenantId);
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            errorHandleForLocalFast(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

// 格式化数组
function formatArray(array) {
    var str = [];
    var arr = array.split(",");
    for (var i = 0; i < arr.length; i++) {
        str.push(arr[i]);
    }
    return str;
}

/**
 * 获取总页数
 */
function getPageCount(totalCount, limit) {
    return Math.ceil(totalCount / limit);
}

// 获得勾选记录个数
function getSelectedCounts() {
    return $("input[type='checkbox']:checked").length;
}

// 重写 选中多少行事件
function getSelectedCount() {
    var length = jQuery('tbody tr span[class="checked"]').length;
    return length;
}

// 参数类型下拉列表
function onSelectClick(V) {
    // onclick="onSelectClick(this)"
    var isSelect = true;
    var selectedOption = V.options[V.selectedIndex];
    $("#serviceId").val(selectedOption.id);
}

// 用户名合法性校验
function isTenantName(tenantName) {
    var reg = /^([u4e00-u9fa5]|[ufe30-uffa0]|[a-za-z0-9_]){3,12}$/;
    return reg.test(tenantName);
}

// 密码合法性校验
function isPassWord(password) {
    // var reg =
    // /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{6,16}$/;
    var reg = /^\S{3,16}$/;
    return reg.test(password);
}

// 校验是否为1-4094的正整数
function isPositiveInt(str) {
    // 0 不是正整数
    if (str && str == "0")
        return false;
    var regex = /^\+?[0-9][0-9]*$/;
    if (regex.test(str) && str > 0 && str < 4095) {
        return true;
    }
    return false;
}

// 校验是否为手机号码或者电话号码
function isTelPhone(str) {
    var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
    var isMob = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1}))+\d{8})$/;
    var str = str.trim();
    if (isMob.test(str) || isPhone.test(str)) {
        return true;
    } else {
        return false;
    }
}

// 校验端口号合法性
function isPort(str) {
    var parten = /^(\d)+$/g;
    if (parten.test(str) && parseInt(str) <= 65535 && parseInt(str) >= 0) {
        return true;
    } else {
        return false;
    }
}

// 校验IP合法性
function isIP(ip) {
    var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    if (reg.test(ip)) {
        ip.match(reg);
        // 每组不能出现“000”或“00”
        if (RegExp.$1 == "000" || RegExp.$1 == "00" || RegExp.$2 == "000" ||
            RegExp.$2 == "00" || RegExp.$3 == "000" || RegExp.$3 == "00" ||
            RegExp.$4 == "000" || RegExp.$4 == "00") {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

// 校验是否为同一网段
function isEqualIPAddress(add1, add2) {
    var res1 = [];
    var res2 = [];
    var addr1 = add1.split(".");
    var addr2 = add2.split(".");
    for (var i = 0, ilen = addr1.length; i < ilen - 1; i++) {
        res1.push(parseInt(addr1[i]));
        res2.push(parseInt(addr2[i]));

    }
    if (res1.join(".") == res2.join(".")) {
        if (parseInt(addr1[ilen - 1]) > parseInt(addr2[ilen - 1])) {
            Showbo.Msg.alert($.i18n.prop('string_checkipaddress'));
            return false;
        }
        return true;
    } else {
        Showbo.Msg.alert($.i18n.prop('string_inputipaddress'));
        return false;
    }
}

// 校验录入IP是否属于网段
function isSameSegment(ip, startIp, endIp) {
    var res1 = [];
    var res2 = [];
    var res3 = [];
    var ips = ip.split(".");
    var addr1 = startIp.split(".");
    var addr2 = endIp.split(".");
    for (var i = 0, ilen = addr1.length; i < ilen - 1; i++) {
        res1.push(parseInt(ips[i]));
        res2.push(parseInt(addr1[i]));
        res3.push(parseInt(addr2[i]));

    }
    if (res1.join(".") == res2.join(".")) {
        if (parseInt(ips[ilen - 1]) <= parseInt(addr1[ilen - 1])) {
            Showbo.Msg.alert($.i18n.prop('string_checkstartip'));
            return false;
        } else if (parseInt(ips[ilen - 1]) >= parseInt(addr2[ilen - 1])) {
            Showbo.Msg.alert($.i18n.prop('string_checkendip'));
            return false;
        }
        return true;
    } else {
        Showbo.Msg.alert($.i18n.prop('string_inputipaddress'));
        return false;
    }
}

// 获取项目根目录
function getRootPath() {
    var curWwwPath = window.document.location.href;
    var pathName = window.document.location.pathname;
    var pos = curWwwPath.indexOf(pathName);
    var localhostPath = curWwwPath.substring(0, pos);
    var projectName = pathName
        .substring(0, pathName.substr(1).indexOf('/') + 1);
    return (localhostPath + projectName);
}

// 日期格式化函数
function fomateDate(nS) {
    var date = new Date(nS);
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date
        .getMonth() + 1) +
        '-';
    D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() +
        ':';
    m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date
        .getMinutes() +
        ':';
    s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    // console.log(Y+M+D+h+m+s);
    return Y + M + D + h + m + s;
}

/**
 * 获取当日时间
 *
 * @returns {String}
 */
function getCurrentBeginDay() {
    var date = new Date();
    Y = date.getFullYear() + '-';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date
        .getMonth() + 1) +
        '-';
    D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return Y + M + D;
}

/**
 * 获取前几天的时间
 *
 * @param n
 * @returns
 */
function getBeforeDate(n) {
    var n = n;
    var d = new Date();
    var year = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (day <= n) {
        if (mon > 1) {
            mon = mon - 1;
        } else {
            year = year - 1;
            mon = 12;
        }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" +
        (day < 10 ? ('0' + day) : day);
    return s;
}

// 应用名称
function appName() {
    var path = location.pathname;
    if (path.indexOf('/') == 0) {
        path = path.substring(1);
    }
    return path.split('/')[0];
}

// 本来就有的
// 刷新父iframe高度 传入flag true 不跳到顶部
function reinitTopIframe(flag) {
    var topWindow = window.top;
    var iframe = $(topWindow.document).find("#urlFrame")[0];
    console.info('------------' + topWindow.document.body.scrollTop);
    //	$(iframe).css("height", "1px");
    iframe.height = '1px';
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    // iframe.height = height;
    $(iframe).css("height", height + "px");

    if (!flag) {
        returnTop(topWindow);
    }
}

function reinitTopIframeById(id) {
    var topWindow = window.top;
    var iframe = $(topWindow.document).find("#" + id)[0];
    console.info('------------' + topWindow.document.body.scrollTop);
    $(iframe).css("height", "1px");
    //    iframe.height = '1px';
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    // iframe.height = height;
    $(iframe).css("height", height + "px");

    console.info('------------' + topWindow.document.body.scrollTop);
    returnTop(topWindow);
}

// 马魁加的
// 重置滚动条高度，去掉滚动条高度
function resetScorll() {
    // innerHeight 文档当前浏览器窗口的真实高度（不包含滚动条）
    returnTop(window.top);
    var urlFrame = window.top.document.getElementById("urlFrame"); // dom对象
    $(urlFrame).css("height", window.top.innerHeight * 0.5).css("min-height",
        window.top.innerHeight * 0.5);

}

/**
 * 消除指定iframe窗口的滚动条
 *
 * @param iframeWin
 *            该iframe的window对象
 * @param iframeId
 *            该iframe的id
 * @param iframeIdSuper
 *            该iframe的父id 可传可不传
 * @param iframeMinHeight
 *              该iframe预留的最小高度
 */
function removeScorll(iframeWin, iframeId, iframeIdSuper, iframeMinHeight) {
    returnTop(iframeWin.parent);
    var iframe = iframeWin.parent.document.getElementById(iframeId);
    // console.info("开始重置iframe的滚动条高度");
    // console.info("当前 " + iframeId + " 的窗口的实际高度为：" + iframeWin.innerHeight);
    // console.info("当前 " + iframeId + " 的父窗口的显示高度为：" +
    // iframeWin.parent.innerHeight);
    if (iframeIdSuper) {
        if (iframeMinHeight) {
            $(iframe).css("height", iframeMinHeight).css("min-height", iframeMinHeight);
        } else {
            $(iframe).css("height", 0).css("min-height", 0);
        }
        // console.info("重置" + iframeId + "的实际高度为：0");
        var iframeSuper = iframeWin.parent.parent.document
            .getElementById(iframeIdSuper);
        // console.info("当前 " + iframeIdSuper + " 的父窗口的显示高度为：" +
        // iframeWin.parent.parent.innerHeight);
        // console.info("当前顶级窗口的高度为：" + iframeWin.top.innerHeight);
        $(iframeSuper).css("height", iframeWin.parent.parent.innerHeight * 0.6)
            .css("min-height", iframeWin.parent.parent.innerHeight * 0.6);
        // console.info("重置" + iframeIdSuper + "的实际高度为：" +
        // iframeWin.parent.parent.innerHeight*0.6);
    } else {
        // console.info("当前顶级窗口的显示高度为：" + iframeWin.top.innerHeight);
        if (iframeMinHeight) {
            $(iframe).css("height", iframeMinHeight).css("min-height", iframeMinHeight);
        } else {
            $(iframe).css("height", iframeWin.parent.innerHeight * 0.6).css(
                "min-height", iframeWin.parent.innerHeight * 0.6);
        }
        // console.info("重置" + iframeId + "的实际高度为：" +
        // iframeWin.parent.innerHeight*0.6);
    }
}

function removeScorllForSubNews(iframeWin, iframeId, iframeIdSuper) {
    returnTop(iframeWin.parent);
    var iframe = iframeWin.parent.document.getElementById(iframeId);
    // console.info("开始重置iframe的滚动条高度");
    // console.info("当前 " + iframeId + " 的窗口的实际高度为：" + iframeWin.innerHeight);
    // console.info("当前 " + iframeId + " 的父窗口的显示高度为：" +
    // iframeWin.parent.innerHeight);
    if (iframeIdSuper) {
        $(iframe).css("height", 0).css("min-height", 500);
        // console.info("重置" + iframeId + "的实际高度为：0");
        var iframeSuper = iframeWin.parent.parent.document
            .getElementById(iframeIdSuper);
        // console.info("当前 " + iframeIdSuper + " 的父窗口的显示高度为：" +
        // iframeWin.parent.parent.innerHeight);
        // console.info("当前顶级窗口的高度为：" + iframeWin.top.innerHeight);
        $(iframeSuper).css("height", iframeWin.parent.parent.innerHeight * 0.6)
            .css("min-height", iframeWin.parent.parent.innerHeight * 0.6);
        // console.info("重置" + iframeIdSuper + "的实际高度为：" +
        // iframeWin.parent.parent.innerHeight*0.6);
    } else {
        // console.info("当前顶级窗口的显示高度为：" + iframeWin.top.innerHeight);
        $(iframe).css("height", iframeWin.parent.innerHeight * 0.6).css(
            "min-height", iframeWin.parent.innerHeight * 0.6);
        // console.info("重置" + iframeId + "的实际高度为：" +
        // iframeWin.parent.innerHeight*0.6);
    }
}

// 马魁加的
// 刷新iframe高度 首页检索 flag表示是不是从iframeId的当前窗口调用该方法，默认从iframeId的当前窗口
function reinitTopIframe4HomeSearch(iframeId, flag, moreHeight) {
    var topWindow;
    if (flag) {
        topWindow = window;
    } else {
        topWindow = window.parent;
    }
    var iframe = $(topWindow.document).find("#" + iframeId)[0]; // searchResultFrame，根据父页面找到searchResultFrame
    // iframe
    iframe.height = "1px";
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    // iframe.height = height;
    if (moreHeight) {
        height += moreHeight; // 加上指定的高度，类似 urlFrame 下的 除searchResultFrame
        // 其他div的高度
    }
    // $(iframe).parent().css("height",height+"px");
    $(iframe).css("height", height + "px");
    var urlFrame = $(topWindow.parent.document).find("#urlFrame")[0];
    // urlFrame.height = height;
    $(urlFrame).css("height", height + "px");
}

function reinitTopIframe4HomeSearchBak(iframeId, flag, moreHeight) {
    var topWindow;
    if (flag) {
        topWindow = window;
    } else {
        topWindow = window.parent;
    }
    var iframe = $(topWindow.document).find("#" + iframeId)[0]; // searchResultFrame，根据父页面找到searchResultFrame
    // iframe
    iframe.height = "1px";
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    // iframe.height = height;
    if (moreHeight) {
        height += moreHeight; // 加上指定的高度，类似 urlFrame 下的 除searchResultFrame
        // 其他div的高度
    }
    // $(iframe).parent().css("height",height+"px");
    $(iframe).css("height", height + "px");
    var urlFrame = $(topWindow.parent.document).find("#urlFrame")[0];
    // urlFrame.height = height;
    $(urlFrame).css("height", height + "px");
}

// 马魁加的
function resetSedParentIframe(iframeId, win) {
    var iframe = $(win.parent.document).find("#" + iframeId)[0];
    iframe.height = "1px";
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    iframe.height = height;
    $(iframe).css("height", height + "px");
    // returnTop(win.parent);
}

function returnTop(topWindow) {
    topWindow.scrollBy(0, -100); // Only for y vertical-axis
    if (topWindow.document.body.scrollTop > 0) {
        sdelay = setTimeout(returnTop(topWindow), 50);
    }
}

/**
 * 为图文混排的正文添加class标签
 */
function addStyleForContentRaw(contentRaw) {
    var resultRaw = '';
    if (contentRaw != null && typeof (contentRaw) != 'undefined') {
        resultRaw = contentRaw.replace(/<img/g,
            '<img class="img-responsive center-block"');
    }
    return resultRaw;
}

function addWindowKeyDownEvent(keyDownEvent) {
    if (document.addEventListener) {
        document.addEventListener("keydown", function (evt) {
            if (evt.keyCode == 13) {
                keyDownEvent();
                return false;
            }
        }, true);
    } else {
        document.attachEvent("onkeydown", function (evt) {
            if (evt.keyCode == 13) {
                keyDownEvent();
                return false;
            }
        });
    }
}

function removeWindowKeyDownEvent() {
    $(document).keydown(function (event) {
        switch (event.keyCode) {
            case 13:
                return false;
        }
    });
}

function fireFoxHandler(evt, keyDownEvent) {
    var content = $("#searchContent").val();
    if (evt.keyCode == 13 && content != "") {
        // c.loadResourceList(1);
        keyDownEvent(1);
        return false;
    }
}

function createNewWindowByPost(URL, params) {
    var tempForm = document.createElement("form");
    tempForm.action = URL;
    tempForm.target = "_blank";
    tempForm.method = "post";
    tempForm.style.display = "none";
    for (var x in params) {
        var opt = document.createElement("input");
        opt.name = x;
        opt.value = params[x];
        tempForm.appendChild(opt);
    }
    document.body.appendChild(tempForm);
    tempForm.submit();
    document.body.removeChild(tempForm);
};

function ieHandler(evt) {
    var content = $("#searchContent").val();
    if (evt.keyCode == 13 && content != "") {
        // c.loadResourceList(1);
        keyDownEvent(1);
        return false;
    }
}


function boxMessage(type, msg) {
    Lobibox.notify(type, {
        size: 'mini',
        msg: msg
    });
}

// 获取运维管理服务地址
function getOperateServerUrl() {
    var operateServerUrl = "";
    ajaxRequest({
        type: 'GET',
        url: 'api/resource/getOperateServerUrl',
        success: function (data) {
            if (data != null) {
                operateServerUrl = data.value;
            } else {
                Global.tip("运维服务地址未配置,请联系运维管理员!");
            }
        }
    });

    return operateServerUrl;
}

// 强强加的
function reinitIframe(frameid) {
    var iframe = $(window.parent.document).find("#" + frameid)[0];
    iframe.height = "1px";
    $(iframe).parent().css("height", "1px");
    var bHeight = iframe.contentWindow.document.body.scrollHeight;
    var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
    var height = Math.max(bHeight, dHeight);
    iframe.height = height + "px";
    $(iframe).parent().css("height", (height + 20) + "px");
    resetSedParentIframe("urlFrame", window.parent);
}

function ajaxRequestRest(opts) {
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: true, //默认异步请求
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }
    // 获取访问令牌
    var token = window.localStorage.getItem("rest_token");
    if (!token) {
        console.warn("当前localStorage中，无token缓存！");
    } else {
        if (!testVildateRest()) {
            console.warn("当前localStorage中，token信息已经超时，请注意！");
        }
    }
    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            errorHandleRest(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

function errorHandle(XMLHttpRequest, textStatus, errorThrown, defaults) {
    var status = XMLHttpRequest.status;
    console.warn("ajax 调用异常，异常返回状态码：" + status + "，响应行信息：" + textStatus);
    switch (status) {
        case 0:		// 请求方式失败，可能原因 1.js跨域请求被限制 （网关超时后响应不会携带header头，会被浏览器认为是跨域限制而响应0）2.connect refuse
            console.warn("请求受到限制，可能原因：1.请求地址不存在，2.js跨域请求被限制，url：" + defaults.url);
            break;
        case 400:
            console.warn("请求错误!");
            boxMessage("error", "请求错误，请检查输入参数格式是否正确");
            // window.location = "/views/error/400.html";
            break;
        case 401: 	// 401 token验证失败
            var res = JSON.parse(XMLHttpRequest.responseText);
            jumpToLogin("token验证失败,原因：" + res.state);
            break;
        case 404:
            console.warn("没有找到访问的请求地址！url：" + defaults.url);
            boxMessage("error", "没有找到访问的请求地址");
            break;
        case 405:
            console.warn("请求地址！url：" + defaults.url + " 不支持该" + defaults.type + "方式请求");
            boxMessage("error", "请求方式不被支持！");
            break;
        case 500:
            console.warn("服务器内部异常！");
            boxMessage("error", "服务器内部异常！");
        default:
            console.warn("未知请求异常" + defaults.url);
            boxMessage("error", "未知请求异常，code：" + status);
            break;
    }
}

function errorHandleRest(XMLHttpRequest, textStatus, errorThrown, defaults) {
    var status = XMLHttpRequest.status;
    console.warn("ajax 调用异常，异常返回状态码：" + status + "，响应行信息：" + textStatus);
    switch (status) {
        case 0:
            console.warn("请求受到限制，可能原因：1.请求地址不存在，2.js跨域请求被限制，url：" + defaults.url);
            boxMessage("error", "请求受到限制");
            break;
        case 400:
            console.warn("请求错误!");
            window.location = "/views/error/400.html";
            break;
        case 401: 	// 401 token验证失败
            var res = JSON.parse(XMLHttpRequest.responseText);
            console.warn("token 验证失败原因，error信息：" + res.state);
            boxMessage("error", "token验证异常，state：" + res.state);
            break;
        case 404:
            console.warn("没有找到访问的请求地址！");
            window.location = "/views/error/404.html#url=" + defaults.url;
            break;
        case 405:
            console.warn("请求地址！url：" + defaults.url + " 不支持该" + defaults.type + "方式请求");
            boxMessage("error", "请求方式不被支持！");
            break;
        case 500:
            console.warn("服务器内部异常！");
            boxMessage("error", "服务器内部异常！");
        default:
            console.warn("未知请求异常" + defaults.url);
            boxMessage("error", "未知请求异常，code：" + status);
            break;
    }
}

function errorHandleForLocalFast(XMLHttpRequest, textStatus, errorThrown, defaults) {
    var status = XMLHttpRequest.status;
    console.warn("ajax 调用异常，异常返回状态码：" + status + "，响应行信息：" + textStatus);
    switch (status) {
        case 0:
            console.warn("请求受到限制，可能原因：1.请求地址不存在，2.js跨域请求被限制，url：" + defaults.url);
            break;
        case 400:
            console.warn("请求错误!");
            window.location = "/views/error/400.html";
            break;
        case 401: 	// 401 token验证失败
            var res = JSON.parse(XMLHttpRequest.responseText);
            console.warn("token 验证失败原因，error信息：" + res.state);
            //boxMessage("error", "token验证异常，state：" + res.state);
            var configs = JSON.parse(window.localStorage.getItem("configs"));
            window.localStorage.clear();
            window.top.location = configs.fastMeltAddress;
            break;
        case 404:
            console.warn("没有找到访问的请求地址！");
            window.location = "/views/error/404.html#url=" + defaults.url;
            break;
        case 405:
            console.warn("请求地址！url：" + defaults.url + " 不支持该" + defaults.type + "方式请求");
            break;
        case 500:
            console.warn("服务器内部异常！");
        default:
            console.warn("未知请求异常" + defaults.url);
            break;
    }
}

function errorHandleForFast(XMLHttpRequest, textStatus, errorThrown, defaults) {
    var status = XMLHttpRequest.status;
    console.warn("ajax 调用异常，异常返回状态码：" + status + "，响应行信息：" + textStatus);
    switch (status) {
        case 0:
            console.warn("请求受到限制，可能原因：1.请求地址不存在，2.js跨域请求被限制，url：" + defaults.url);
            break;
        case 400:
            console.warn("请求错误!");
            window.location = "/views/error/400.html";
            break;
        case 401: 	// 401 token验证失败
            /*var res = JSON.parse(XMLHttpRequest.responseText);
            console.warn("token 验证失败原因，error信息：" + res.state);
            //boxMessage("error", "token验证异常，state：" + res.state);
            var configs = JSON.parse(window.localStorage.getItem("configs"));
            window.localStorage.clear();
            window.top.location = configs.fastMeltAddress;
            break;*/
            var res = JSON.parse(XMLHttpRequest.responseText);
            var configInfo = JSON.parse(window.localStorage.getItem("configs"));
            console.warn("token 验证失败原因，error信息：" + res.state);
            window.localStorage.clear();
            boxMessage("error", "token验证异常，state：" + res.state);
            //跳转到登陆页
            var uiVersion = configInfo.uiVersion;
            var newTimestamp = new Date().getTime();
            if (uiVersion == "CCS") {
                window.location.href = configInfo.pubLogoutUrl + '?service=' + configInfo.serverNameUrl + "?random=" + newTimestamp;
            } else {
                window.location.href = configInfo.serverNameUrl + '/logout?service=' + configInfo.serverNameUrl + "?random=" + newTimestamp;
            }
            break;
        case 404:
            console.warn("没有找到访问的请求地址！url：" + defaults.url);
            window.location = "/views/error/404.html#url=" + defaults.url;
            break;
        case 405:
            console.warn("请求地址！url：" + defaults.url + " 不支持该" + defaults.type + "方式请求");
            boxMessage("error", "请求方式不被支持！");
            break;
        case 500:
            console.warn("服务器内部异常！");
            boxMessage("error", "服务器内部异常！");
        default:
            console.warn("未知请求异常" + defaults.url);
            boxMessage("error", "未知请求异常，code：" + status);
            break;
    }
}

function testVildateRest() {
    var expTime = parseInt(window.localStorage.getItem("rest_expTime"));
    if (expTime) {
        var nowTime = new Date().getTime();
        if (nowTime > expTime - 2 * 60 * 1000) { // 两分钟的预留时间
            // @TODO 移除token头，重新获取token？
            return false; // token已经过期
        } else {
            return true;
        }
    } else {
        return false; // 缓存中不存在token信息
    }
}

function ajaxRequest4LocalRest(opts) {
    // 一.设置默认参数
    var defaults = {
        url: '',
        type: '',
        data: '',
        cache: true,
        async: false,
        dataType: 'json',
        contentType: "application/json;charset=UTF-8",
        success: function () {
        },
        error: function () {
        }
    };

    // 二.用户参数覆盖默认参数
    for (var key in opts) {
        defaults[key] = opts[key];
    }
    var userInfo = JSON.parse(window.localStorage.getItem("ccRestUserInfo"));
    var userId = userInfo.userId;
    var tenantId = userInfo.tenantId;
    var token = userInfo.token;
    // 三.开始组装ajax
    $.ajax({
        url: defaults.url,
        type: defaults.type,
        data: defaults.data,
        async: defaults.async,
        cache: defaults.cache,
        dataType: defaults.dataType,
        contentType: defaults.contentType,
        beforeSend: function (XHR) {
            XHR.setRequestHeader("userId", userId);
            XHR.setRequestHeader("tenantId", tenantId);
            XHR.setRequestHeader("token", token); // 只需传递访问令牌 token
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            errorHandleRest(XMLHttpRequest, textStatus, errorThrown, defaults);
        },
        success: defaults.success
    });
}

//王强加的
//1.操作前确认信息
function beforeOperateConfirm(msgstr) {
    var msg = '您真的确定要' + msgstr + '吗？\n\n请确认！';
    if (confirm(msg)) {
        return true;
    } else {
        return false;
    }
}

//2.获取当前时刻年月日时分秒,//传入time，算出多少小时前的时分秒 （该方法可用于获取当前时间、几个小时前时间、一周前时间）
function getDate(hours) {
    var date = new Date(new Date().getTime() - hours * 3600000);
    var year = date.getFullYear(); //获取当前年份
    var mon = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1); //获取当前月份
    var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate(); //获取当前日
    var h = date.getHours() > 9 ? date.getHours() : '0' + date.getHours(); //获取小时
    var m = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes(); //获取分钟
    var s = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds(); //获取秒
    return year + '-' + mon + '-' + day + ' ' + h + ':' + m + ':' + s;
}

//3.发送通用搜索请求
var latestTimestamp
var generalSearchNewsAjax = function (data, func, url) {
    if (data.start === 1 || data.start === 0 || data.start == null || data.start === undefined) {
        latestTimestamp = new Date().getTime()
    }
    data.latestTimestamp = latestTimestamp
    ajaxRequest({
        type: 'post',
        async: true,
        url: url,
        data: JSON.stringify(data),
        success: func
    });
};

//4.增加art-template模板过滤器dateFormat--将“2018-02-24 10:44:00”格式转化为“2018/02/24”
/* template.defaults.imports.dateFormat = function (date) {
    return date.substr(0, 10).split('-').join('/');
};

//7.增加art-template模板过滤器urlCode--将中文进行URL编码
template.defaults.imports.urlCode = function (data) {
    return encodeURIComponent(data);
};

//8.增加art-template模板过滤器deleteLabel--去掉返回数据中的标签，只展示文本内容
template.defaults.imports.deleteLabel = function (data) {
    return data.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "").trim();
};

//增加art-template模板过滤器clearTitle，主要用于过滤标题中的异常字符，例如&quot;
template.defaults.imports.clearTitle = function (title) {
  // 判断title是否存在，如果不存在直接返回空字符串
  if (!title) {
    return '';
  }

  //将字符串&quot;转化为"，去掉��
  return title
    .replace(/&nbsp;/g, '')
    .replace(/&quot;/g, '"')
    .replace(/�+/g, '')
    .replace(/&amp;quot;/g, '"')
    .trim();
}; */

//删除字符串中的标签
function deleteLabel(data) {
    return data.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "").trim();
}

var showJumpToLogin = false;
//重新登录
function jumpToLogin(hintWords) {
    if (!showJumpToLogin) {
        boxMessage("error", hintWords);
        setTimeout(function () {
            var configInfo = JSON.parse(window.localStorage.getItem("configs"));
            var uiVersion = configInfo.uiVersion;
            var newTimestamp = new Date().getTime();
            var headerClassify = localStorage.getItem('headerClassify')
            if (headerClassify.indexOf('gateway') !== -1) {
                window.location.href = '//' + location.host + partPath + '/common/logout'
            } else {
                if (uiVersion == "CCS") {
                    window.location.href = configInfo.pubLogoutUrl + '?service=' + configInfo.serverNameUrl + "?random=" + newTimestamp;
                } else {
                    window.location.href = configInfo.serverNameUrl + '/logout?service=' + configInfo.serverNameUrl + "?random=" + newTimestamp;
                }
            }
        }, 6000);
        showJumpToLogin = true;
    }
}

//获取url中的参数值
function getDataFromUrl(name) {
    var url = location.search.substr(1);
    var urlArr = url.split('&');
    var urlObj = {};
    $(urlArr).each(function (i, v) {
        var name = v.split('=')[0];
        var value = v.split('=')[1]
        urlObj[name] = value;
    });
    return urlObj[name];
}

/*
* 封装该项目内容导航插件
* 须在html里面找到bona-nav和bona-content
* */
(function ($) {
    $.fn.bonaNav = function (options) {
        var defaultOptions = {
            type: 'switch'
        };//默认值，暂时没有，后续拓展
        var opts = $.extend(defaultOptions, options);//合并默认值和传入参数
        var bonaNav = $(this);


        bonaNav.find('.bona-nav li a').click(function () {
            var index = bonaNav.find('.bona-nav li').index($(this).parent());//导航高亮元素的index
            var funcNum = 'func' + index;//对应需执行的函数
            $(this).parent().addClass('active').siblings().removeClass('active');//导航高亮

            //如果需要内容切换则执行显示隐藏内容
            if (opts.type == 'switch') {
                bonaNav.find('.bona-content >div:eq(' + index + ')').show().siblings().hide();//对应内容展示
            }

            //如果存在公共函数，则执行公共函数
            if (opts['func']) {
                opts['func']();
            }

            //如果存在展示内容需要执行的函数，则执行此函数;
            if (opts[funcNum]) {
                opts[funcNum]();
            }
        });

    }
})(jQuery);

//去掉数组中的重复对象
function uniqObjFromArr(arr, attr) {
    var hash = {};
    return arr.reduce(function (item, next) {
        hash[next[attr]] ? '' : hash[next[attr]] = true && item.push(next);
        return item;
    }, []);
}

//使用flex布局将我的图文居中显示的时候，会有问题，fixed it
//参数classOrId为ul的类或者id，参数liPadding为li的padding大小
function fixFlexStyle(classOrId, liPadding) {
    var $targetUl = $(classOrId);
    $targetUl.find('.empty-li').remove();
    var produceListWidth = $targetUl.width();
    var produceItemWidth = $targetUl.find('>li').width() + (liPadding * 2);
    var oneLineProduceNum = Math.floor(produceListWidth / produceItemWidth);
    var lastLineProduceNum = $targetUl.find('>li').length % oneLineProduceNum;
    var appendNum = 0;
    if (lastLineProduceNum) {
        appendNum = oneLineProduceNum - lastLineProduceNum;
    }
    for (var i = 0; i < appendNum; i++) {
        $targetUl.append('<li class="empty-li"></li>');
    }
}

//函数防抖（只执行最后一次），使用示例window.onresize = this.$utils.decounce(fn, 3000);
function decounce(fn, delay = 500) {
  let timer = null;
  return () => {
    let context = this;
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

//函数节流（保持一个限定频率执行），使用示例window.onresize = this.$utils.throttle(fn, 3000);
function throttle(fn, delay = 500) {
  let canRun = true;
  return function() {
    if (canRun) {
      let context = this;
      let args = arguments;
      canRun = false;
      setTimeout(function() {
        canRun = true;
        fn.apply(context, args);
      }, delay);
    }
  };
}

export default {
    getDataFromUrl,
    getDate,
    ajaxRequest,
    boxMessage,
    generalSearchNewsAjax,
    decounce,
    throttle,
}

